import React from 'react';
import { submitForm } from '@kineticdata/react';
import { Icon } from '../Icon';
import classNames from 'classnames';

export const generateFilterFormButtons =
  ({
    applyLabel = 'Apply',
    applyColor = 'outline-primary',
    resetLabel = 'Reset',
    resetColor = 'link-primary',
    size = 'sm',
  } = {}) =>
  props => {
    const resetFilterForm = () => e => {
      e && e.preventDefault && e.preventDefault();
      const values = props.fields.map(() => null);
      submitForm(props.formKey, { values });
    };
    const canReset = props.fields.some(f => !!f.value);

    return (
      <>
        <button
          className={classNames(`btn btn-${applyColor}`, {
            'btn-sm': size === 'sm',
          })}
          type="submit"
          disabled={!props.dirty || props.submitting}
          onClick={props.submit}
        >
          {props.submitting ? (
            <Icon name="circle-notch" md spin />
          ) : (
            <Icon name="check" md />
          )}
          <span>{applyLabel}</span>
        </button>
        <button
          className={classNames(`btn btn-${resetColor}`, {
            'btn-sm': size === 'sm',
          })}
          type="button"
          disabled={!canReset}
          onClick={resetFilterForm()}
        >
          {resetLabel}
        </button>
      </>
    );
  };

export const FilterFormButtons = generateFilterFormButtons();
